import NotifyType from "./NotifyType";

class NotifyTypeClass {
  constructor(private readonly _value: NotifyType = NotifyType.SAVE_SUCCESS) {
  }

  get value() {
    return this._value;
  }
}

export default NotifyTypeClass;
